import useSWR from 'swr';
import { CcConnectionStats } from 'types';
import api from 'utils/api';

export function useCollabStats(profileId?: number) {
  const {
    data,
    error,
    mutate: refetch,
  } = useSWR<CcConnectionStats | null>(
    profileId ? `collab-stats-profile-${profileId}` : null,
    profileId
      ? async () => {
          const stats: CcConnectionStats = await api.collabClub.getProfileStats({ id: profileId });
          return stats;
        }
      : null,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 30 * 1000, // 30 seconds
    }
  );

  return {
    stats: data || null,
    monthlyConnectionsUsed: data?.monthlyConnectionsUsed ?? 0,
    monthlyConnectionLimit: data?.monthlyConnectionLimit ?? 0,
    remainingConnections: data?.remainingConnections ?? 0,
    nextResetDate: data?.nextResetDate,
    isLoading: !data && !error,
    error,
    refetch,
  };
}
